import React from "react";

const svgStyles = {
  cursor: "pointer",
};

const CloseIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={18}
    height={18}
    fill="none"
    style={svgStyles}
    {...props}
  >
    <path
      style={svgStyles}
      fill="#9B27AF"
      d="M9.093 9.881 5.155 13.82a.54.54 0 0 1-.787 0 .54.54 0 0 1 0-.787l3.937-3.938-3.937-3.938a.54.54 0 0 1-.169-.393.54.54 0 0 1 .169-.394.54.54 0 0 1 .394-.169.54.54 0 0 1 .393.169l3.938 3.937 3.938-3.937a.54.54 0 0 1 .787 0 .54.54 0 0 1 .169.394.54.54 0 0 1-.169.393L9.88 9.094l3.938 3.937a.54.54 0 0 1 .169.394.54.54 0 0 1-.169.394.54.54 0 0 1-.787 0L9.092 9.88Z"
    />
  </svg>
);
export default CloseIcon;
